import "./link-list-item.scss";

function LinkListItem(props) {
    const url = props.url;
    const text = props.text;
    const target = props.target;
    const image = props.image;
    const description = props.description;

    return (
        <div className="row mb-4 link-list-item">
            <div className="col-4 col-md-3 col-lg-2 col-xl-1">
                <a href={url} target={target}>
                    <img src={image} className="app-icon"></img>
                </a>
            </div>
            <div className="col-8 col-md-9 col-lg-10 col-xl-11 text-start">
                <a href={url} target={target}>
                    {text}
                </a>
                <p className="link-description">{description}</p>
            </div>
        </div>
    );
}

export default LinkListItem;
